import React, { Fragment } from "react"
import { Link } from "react-router-dom"
import { connect } from "react-redux"
import { logout } from "../../actions/auth"
import PropTypes from "prop-types"

const Navbar = ({ auth: { isAuthenticated, loading }, logout }) => {
  const authLinks = (
    <ul>
      <li>
        <Link to="/dashboard">
          <i className="fas fa-user"></i>{" "}
          <span className="hide-sm">Dashboard</span>
        </Link>
      </li>
      <li>
        <Link to="/myBookings">myBookings</Link>
      </li>
      <li>
        <a onClick={logout} href="#!">
          <i className="fas fa-sign-out-alt"></i>{" "}
          <span className="hide-sm">Logout</span>
        </a>
      </li>
    </ul>
  )
  const guestLinks = (
    <ul>
      <li>
        <Link to="/halls">Halls</Link>
      </li>
      <li>
        <Link to="/register">
          <i className="fas fa-user-plus" /> Register
        </Link>
      </li>
      <li>
        <Link to="/login">
          <i className="fas fa-user-circle" /> SignIn
        </Link>
      </li>
    </ul>
  )
  return (
    <nav className="navbar bg-dark">
      <h1>
        <Link to={!isAuthenticated ? "/" : "/dashboard"}>
          <i className="fa fa-calendar" aria-hidden="true" /> Easy Booking
        </Link>
      </h1>
      {!loading && (
        <Fragment>{isAuthenticated ? authLinks : guestLinks}</Fragment>
      )}
    </nav>
  )
}

Navbar.propTypes = {
  logout: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
}

const mapStateToProps = (state) => ({
  auth: state.auth,
})

export default connect(mapStateToProps, { logout })(Navbar)
